export const kMatterListCacheDuration = 60 * 1000 // matters-list cache: a non-forced refresh within this window is skipped
export const kMatterDetailCacheDuration = 30 * 1000 // matter-detail cache: a non-forced refresh within this window is skipped
export const kMatterPollingIntervalMs = 30 * 1000 // how often MatterLayout polls the open matter's detail

// BE error detail strings
export const kBEMatterAlreadyExistsDetail = 'Matter already exists'

// User-facing error messages
export const kMatterDialogGenericErrorMessage = 'Something went wrong. Please try again.'
export const kMatterNameExistsErrorMessage = 'A matter with this name already exists.'

export const kMattersRoute = '/dashboard/matters'
export const kSessionStorageActiveMatterIdKey = 'activeMatterId'

export const kMaxMatterContextLength = 4000
export const kMaxMatterHardLimit = 5000

/** Fallback label when a matter has no name or is missing */
export const kUntitledMatterLabel = 'Untitled Matter'
